import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";

if (process.env.NODE_ENV === "development") {
  const isFirebasePermission = (value) => {
    const text = `${value?.code || ""} ${value?.message || ""} ${value || ""}`;
    return text.includes("permission-denied") || text.includes("Missing or insufficient permissions");
  };
  window.addEventListener("unhandledrejection", (event) => {
    if (isFirebasePermission(event.reason)) event.preventDefault();
  }, true);
  const origError = console.error;
  console.error = (...args) => {
    if (args.some(isFirebasePermission)) return;
    origError.apply(console, args);
  };
}

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
